import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  ON_MY_TICKETS_MOUNT,
  ON_MY_PASSES_MOUNT,
  ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS,
  ON_MY_TICKETS_PAST_MOUNT_SUCCESS,
  ON_MY_TICKETS_MOUNT_ERROR,
  ON_MY_PASSES_MOUNT_ERROR,
  SEND_HOST_MESSAGE,
  CANCEL_ORDER,
  TRANSFER_TICKET,
  CANCEL_TICKET_TRANSFER,
  RESEND_TICKET_TRANSFER,
  UPDATE_COST_ITEM_HOST_FIELDS,
  UPDATE_TICKET_HOST_FIELDS,
  ADD_FLASH_MESSAGE,
  PAGINATION_MORE_ORDERS,
  TOGGLE_PASS_OPEN
} from '../actions';

import {
  fetchMyTicketsData,
  fetchMyPassesData,
  fetchCostItems,
  sendHostMessage,
  cancelOrder,
  transferTicket,
  cancelTicketTransfer,
  resendTicketTransfer,
  updateCostItemHostFields,
  updateTicketHostFields,
  addFlashMessage,
  fetchOrders,
  togglePassOpen,
  redirectToSignIn
} from './sagas';


// Watchers
export function* onMyTicketsInit() {
  yield takeLatest(ON_MY_TICKETS_MOUNT, fetchMyTicketsData);
}

export function* onMyPassesInit() {
  yield takeLatest(ON_MY_PASSES_MOUNT, fetchMyPassesData);
}

export function* onMyTicketsCurrentSuccess() {
  yield takeLatest(ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS, () => fetchCostItems('current'));
}

export function* onMyTicketsPastSuccess() {
  yield takeLatest(ON_MY_TICKETS_PAST_MOUNT_SUCCESS, () => fetchCostItems('past'));
}

export function* redirectToSignInOnError() {
  yield takeLatest(ON_MY_TICKETS_MOUNT_ERROR, () => redirectToSignIn('dashboard/tickets'));
}

export function* redirectToSignInOnPassesError() {
  yield takeLatest(ON_MY_PASSES_MOUNT_ERROR, () => redirectToSignIn('dashboard/tickets#passes'));
}

export function* onRequestRefund() {
  yield takeLatest(SEND_HOST_MESSAGE, sendHostMessage);
}

export function* onRequestCancel() {
  yield takeLatest(CANCEL_ORDER, cancelOrder);
}

export function* onRequestTransferTicket() {
  yield takeLatest(TRANSFER_TICKET, transferTicket);
}

export function* onRequestCancelTicketTransfer() {
  yield takeLatest(CANCEL_TICKET_TRANSFER, cancelTicketTransfer);
}

export function* onRequestResendTicketTransfer() {
  yield takeLatest(RESEND_TICKET_TRANSFER, resendTicketTransfer);
}

export function* onRequestUpdateCostItemHostFields() {
  yield takeLatest(UPDATE_COST_ITEM_HOST_FIELDS, updateCostItemHostFields);
}

export function* onRequestUpdateTicketHostFields() {
  yield takeLatest(UPDATE_TICKET_HOST_FIELDS, updateTicketHostFields);
}

export function* onAddFlashMessage() {
  yield takeEvery(ADD_FLASH_MESSAGE, addFlashMessage);
}

export function* onPagination() {
  yield takeEvery(PAGINATION_MORE_ORDERS, fetchOrders);
}

export function* onTogglePassOpen() {
  yield takeLatest(TOGGLE_PASS_OPEN, togglePassOpen);
}



// WEBPACK FOOTER //
// ./src/modules/my-tickets/actions/watchers.js